import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, InfiniteScroll, inject, NothingHere, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFillExclamationCircleFill } from '@react-icons/all-files/bs/BsFillExclamationCircleFill';

import { Form } from 'reactstrap';
import { ContractsStore } from '../../Contracts/ContractsStore';
import { AppStore } from '../../Core/AppStore';
import { NocServersStore } from '../../NocServers/NocServersStore';
import { ImportFormRow } from './ImportFormRow';
import { BsTv } from '@react-icons/all-files/bs/BsTv';

export interface IImportListProps {
    onSubmit(event: React.FormEvent<HTMLFormElement>): void;
    readonly formStores: FormStore<Mri.Web.Internal.Controllers.Displays.UpdateDisplayModel>[];
    readonly columns: string[];
    readonly emptyColumns: string[];
}

@autoinject
@observer
export class ImportFormList extends React.Component<IImportListProps> {
    public async componentDidMount() {
        try {
            await this.contractsStore.loadAllAsync(true);
            await this.nocServersStore.loadAllAsync(true);
        } catch (e: any) {
            this.appStore.setError(e);
        }
    }

    public render() {
        return (
            <div className="container-fluid m-0 p-0">
                <Form onSubmit={this.props.onSubmit} onKeyDown={e => e.keyCode == 13 && e.preventDefault()}>
                    <button type="submit" className="btn btn-primary m-3">
                        Submit
                    </button>
                    <InfiniteScroll
                        throttle={100}
                        threshold={300}
                        hasMore={this.hasMore}
                        onLoadMore={this.loadMore}
                        className="overflow-x-scroll"
                        container={this.appStore.mainContainer} // this.listContainer WHY THOUGH IT WON'T WORK
                    >
                        <table className="table-striped w-100 import-display-table">
                            <thead className="bg-color">
                                <tr>
                                    {this.props.columns.includes('SerialNumber') && (
                                        <th>
                                            Serial Number{' '}
                                            {this.props.emptyColumns.includes('SerialNumber') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}
                                    {this.props.columns.includes('CameraIP') && (
                                        <th>
                                            Camera IP{' '}
                                            {this.props.emptyColumns.includes('CameraIP') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}
                                    {this.props.columns.includes('Active') && (
                                        <th>
                                            Active{' '}
                                            {this.props.emptyColumns.includes('Active') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}
                                    {this.props.columns.includes('Input1IP') && (
                                        <th>
                                            Input 1 IP
                                            {this.props.emptyColumns.includes('Input1IP') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}
                                    {this.props.columns.includes('Input1Password') && (
                                        <th>
                                            Input 1 Password{' '}
                                            {this.props.emptyColumns.includes('Input1Password') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Input2IP') && (
                                        <th>
                                            Input 2 IP{' '}
                                            {this.props.emptyColumns.includes('Input2IP') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Input2Password') && (
                                        <th>
                                            Input 2 Password{' '}
                                            {this.props.emptyColumns.includes('Input2Password') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('DisplayBoardIP') && (
                                        <th>
                                            DisplayBoard IP{' '}
                                            {this.props.emptyColumns.includes('DisplayBoardIP') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('DisplayBoardPort') && (
                                        <th>
                                            DisplayBoard Port{' '}
                                            {this.props.emptyColumns.includes('DisplayBoardPort') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('DisplayBoardWebsitePort') && (
                                        <th>
                                            DisplayBoard Website Port{' '}
                                            {this.props.emptyColumns.includes('DisplayBoardWebsitePort') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('NocServer') && (
                                        <th>
                                            NocServer{' '}
                                            {this.props.emptyColumns.includes('NocServer') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Contract') && (
                                        <th>
                                            {this.props.emptyColumns.includes('Contract') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}{' '}
                                            Contract
                                        </th>
                                    )}

                                    {this.props.columns.includes('CustomerSiteID') && (
                                        <th>
                                            Site ID{' '}
                                            {this.props.emptyColumns.includes('CustomerSiteID') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('CustomerSiteID2') && (
                                        <th>
                                            Site ID 2{' '}
                                            {this.props.emptyColumns.includes('CustomerSiteID2') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('CustomerDisplayID') && (
                                        <th>
                                            Customer Display ID{' '}
                                            {this.props.emptyColumns.includes('CustomerDisplayID') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('CustomerDisplayID2') && (
                                        <th>
                                            Customer Display ID 2{' '}
                                            {this.props.emptyColumns.includes('CustomerDisplayID2') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('SslPort') && (
                                        <th>
                                            SSL Port{' '}
                                            {this.props.emptyColumns.includes('SslPort') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('ModemIP') && (
                                        <th>
                                            Modem IP{' '}
                                            {this.props.emptyColumns.includes('ModemIP') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Address1') && (
                                        <th>
                                            Address 1{' '}
                                            {this.props.emptyColumns.includes('Address1') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Address2') && (
                                        <th>
                                            Address 2{' '}
                                            {this.props.emptyColumns.includes('Address2') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('City') && (
                                        <th>
                                            City{' '}
                                            {this.props.emptyColumns.includes('City') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('StateOrProvince') && (
                                        <th>
                                            State/Province{' '}
                                            {this.props.emptyColumns.includes('StateOrProvince') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Country') && (
                                        <th>
                                            Country{' '}
                                            {this.props.emptyColumns.includes('Country') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('PostalCode') && (
                                        <th>
                                            Postal Code{' '}
                                            {this.props.emptyColumns.includes('PostalCode') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Description') && (
                                        <th>
                                            Description{' '}
                                            {this.props.emptyColumns.includes('Description') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <BsFillExclamationCircleFill className="text-danger" />
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}

                                    {this.props.columns.includes('Comments') && (
                                        <th>
                                            Comments{' '}
                                            {this.props.emptyColumns.includes('Comments') && (
                                                <Tooltip message="Warning: Over half of the entries are blank!">
                                                    <Tooltip message="Warning: Over half of the entries are blank!">
                                                        <BsFillExclamationCircleFill className="text-danger" />
                                                    </Tooltip>
                                                </Tooltip>
                                            )}
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.formStores.slice(0, this.scrollCount).map(f => (
                                    <ImportFormRow
                                        key={f.fields.serialNumber.value}
                                        formStore={f}
                                        serialNumber={f.fields.serialNumber.value}
                                        columns={this.props.columns}
                                        emptyColumns={this.props.emptyColumns}
                                    />
                                ))}
                            </tbody>
                        </table>

                        <NothingHere
                            empty={!this.props.formStores.length}
                            icon={<BsTv />}
                            label="No displays to import"
                            loading={false}
                        />
                    </InfiniteScroll>
                </Form>
            </div>
        );
    }

    @computed
    private get hasMore() {
        return this.scrollCount < this.props.formStores.length;
    }

    @bind
    @action
    private loadMore() {
        this.scrollCount += 40;
    }

    @observable
    private scrollCount = 40;
    @inject
    private appStore!: AppStore;
    @inject
    private contractsStore!: ContractsStore;
    @inject
    private nocServersStore!: NocServersStore;
}
